import { GeneralModel } from "./general.model";

export class ModulePage extends GeneralModel {
    url: string;
    backColor: string;
    icon: string;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/modulePage.model.ts